"use client";
import * as React from "react";
const SvgUnfoldLessOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 10 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M.41 14.59 1.83 16 5 12.83 8.17 16l1.41-1.41L5 10zM9.59 1.41 8.17 0 5 3.17 1.83 0 .41 1.41 5 6z" }));
export {
  SvgUnfoldLessOutlined as default
};
